import 'react-app-polyfill/ie11';
import 'core-js/features/object/values';
import 'core-js/features/object/entries';
import 'core-js/features/promise/finally';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

ReactDOM.render(<App />, document.getElementById('app'));